/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetDomains200ResponseInner,
} from '../models/index';
import {
    GetDomains200ResponseInnerFromJSON,
    GetDomains200ResponseInnerToJSON,
} from '../models/index';

/**
 * 
 */
export class ShopApi extends runtime.BaseAPI {

    /**
     */
    async getDomainsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDomains200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/shop/domains`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDomains200ResponseInnerFromJSON));
    }

    /**
     */
    async getDomains(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDomains200ResponseInner>> {
        const response = await this.getDomainsRaw(initOverrides);
        return await response.value();
    }

}
